import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';

import { type AuthMatch, type AuthType, USER_TYPES, type UserType } from '@kernel';

import { AuthStore } from './auth.store';
import { matchAuth } from './auth.util';

const isUserType = (v: string): v is UserType => USER_TYPES.includes(v as UserType);

@Directive({
  selector: '[ksAuth]',
})
export class AuthDirective {
  readonly values = input.required<string[]>({ alias: 'ksAuth' });
  readonly type = input<AuthType>('PERMISSION', { alias: 'ksAuthType' });
  readonly match = input<AuthMatch>('ANY', { alias: 'ksAuthMatch' });

  private readonly authStore = inject(AuthStore);
  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly vcr = inject(ViewContainerRef);

  private hasView = false;

  constructor() {
    effect(() => {
      const values = this.values();
      const type = this.type();
      const match = this.match();

      const isAuthorized = matchAuth(values, match, (v) =>
        type === 'ROLE'
          ? isUserType(v) && this.authStore.hasRole(v)
          : this.authStore.hasPermission(v),
      );

      this.toggleView(isAuthorized);
    });
  }

  private toggleView(show: boolean): void {
    if (show && !this.hasView) {
      this.vcr.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!show && this.hasView) {
      this.vcr.clear();
      this.hasView = false;
    }
  }
}
